const FlowSteps = {
  PROFILE_SELECTED: 'profile',
  BRANCH_SELECTED: 'branch',
  LOGGED_IN: 'login',
};

const Screens = {
  SEARCH: 'search',
  EDIT: 'edit',
  LOGIN: 'login',
};

const loginDefaultState = {
  loginFlowEnabled: false,
  employees: [],
  employeeConflicts: [],
  branches: [],
  selectedEmployee: {},
  processing: false,
  loginComplete: false,
  hasLoggedOut: false,
  flowSteps: {
    [`${FlowSteps.PROFILE_SELECTED}`]: false,
    [`${FlowSteps.BRANCH_SELECTED}`]: false,
    [`${FlowSteps.LOGGED_IN}`]: false,
  },
};

const commonFields = {
  employeeId: {
    name: 'employeeId',
    validations: {
      minLength: 1,
    },
  },
  nmlsId: {
    name: 'nmlsId',
    validations: {
      matchRegexp: /^[0-9]{0,12}$/,
    },
  },
};

const defaultSchema = {
  fields: [
    {
      name: 'firstName',
      validations: {
        minLength: 1,
      },
    },
    {
      name: 'lastName',
      validations: {
        minLength: 1,
      },
    },
    {
      name: 'email',
      type: 'email',
      validations: {
        isEmail: true,
      },
    },
    {
      name: 'phone',
      validations: {
        matchRegexp: /^\([0-9]{3}\)\s*[0-9]{3}-[0-9]{4}$|^[0-9]{10}$/,
      },
    },
    commonFields.employeeId,
  ],
  required: ['firstName', 'lastName', 'email', 'phone'],
};

export { commonFields, defaultSchema, FlowSteps, Screens, loginDefaultState };
